export const CELL_COUNT_31_60 =
  '* Indicates a cell count from 31 to 60. Projections may be unstable, use with caution.';
export const CELL_COUNT_BELOW_31 =
  '**Indicates a cell count below 31. Projections are likely unstable, use with caution.';

export const MRI_CELL_COUNT_BELOW_50 = '* Values in this cell are unstable due to respondent count below 50.';
export const MRI_CELL_COUNT_BELOW_25 = '** Values in this cell are unstable due to respondent count below 25.';
export const MRI_CELL_COUNT_25_49 = '* Values in this cell are unstable due to respondent count between 25 - 49.';
export const MRI_CELL_COUNT_BELOW_31 = '** Values in this cell are unstable due to respondent count below 31.';
export const MRI_CELL_COUNT_31_59 = '* Values in this cell are unstable due to respondent count between 31 - 59.';
export const INSIGHT_360_DEEPDIVE_CELL_COUNT_MSG = 'Projections relatively unstable, use with caution.';

export const WEBSITE = 'Website';
export const INDEX = 'Index';
export const PERCENT = 'Percent';
export const TABLE_STILL_LOADING = 'Table is still loading';

export const DDNHCS_FOOTER_NOTE = `${String.fromCharCode(10020)} Denotes entities that are modeled onto the Dynamic Digital sample`;
